import IdNameModel from '@/domain/models/id-name-model'

// @Deprecated
export interface Job {
  getAllOfUserCompany(): Promise<Job.Model[]>
}

export namespace Job {
  export type Model = IdNameModel
  export const Key = 'job'
}
